/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

export { default as en_US } from './en-US.js';
export { default as zh_CN } from './zh-CN.js';
export { default as zh_HK } from './zh-HK.js';



// WEBPACK FOOTER //
// ./src/i18n/index.js